"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./styles.css");
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _moment3 = _interopRequireDefault(require("moment"));
require("react-datepicker/dist/react-datepicker.css");
var _pt = _interopRequireDefault(require("date-fns/locale/pt"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function DateInput(props) {
  //PROPS
  var isDateTime = props.isDateTime,
    value = props.value,
    showTitle = props.showTitle,
    containerClass = props.containerClass,
    mandatory = props.mandatory,
    label = props.label,
    editable = props.editable,
    inputClass = props.inputClass,
    dateFormat = props.dateFormat,
    onChange = props.onChange,
    dropdownMode = props.dropdownMode,
    error = props.error;
  //STATE
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    date = _useState2[0],
    setDate = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    dateText = _useState4[0],
    setDateText = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    isEmpty = _useState6[0],
    setIsEmpty = _useState6[1];
  (0, _react.useEffect)(function () {
    if (value) {
      setDate((0, _moment3.default)(value).toDate());
      setDateText((0, _moment3.default)(value).toDate());
    }
  }, [value]);
  function handleOnBlur() {
    setIsEmpty(!value ? 'Campo obrigatório' : null);
  }
  function isDateValid(text) {
    var day, month, year, leapYear;
    var ableToGetDay = (text === null || text === void 0 ? void 0 : text.length) >= 1;
    var ableToGetMonth = (text === null || text === void 0 ? void 0 : text.length) >= 5;
    var ableToGetYear = (text === null || text === void 0 ? void 0 : text.length) >= 6;
    if (ableToGetDay) day = parseInt(text === null || text === void 0 ? void 0 : text.slice(0, 2));
    if (ableToGetMonth) month = parseInt(text === null || text === void 0 ? void 0 : text.slice(3, 5)) - 1;
    if (ableToGetYear) year = parseInt(text === null || text === void 0 ? void 0 : text.slice(6, 10));
    var isLeapYear = new Date(year, 1, 29).getMonth() === 1;
    isLeapYear ? leapYear = 29 : leapYear = 28;
    var daysAndMonths = [{
      month: 1,
      lastDay: 31
    }, {
      month: 2,
      lastDay: leapYear
    }, {
      month: 3,
      lastDay: 31
    }, {
      month: 4,
      lastDay: 30
    }, {
      month: 5,
      lastDay: 31
    }, {
      month: 6,
      lastDay: 30
    }, {
      month: 7,
      lastDay: 31
    }, {
      month: 8,
      lastDay: 31
    }, {
      month: 9,
      lastDay: 30
    }, {
      month: 10,
      lastDay: 31
    }, {
      month: 11,
      lastDay: 30
    }, {
      month: 12,
      lastDay: 31
    }];
    var isDayValid = daysAndMonths.find(function (obj) {
      return day <= obj.lastDay;
    });
    var areDayAndMonthValid = daysAndMonths.find(function (obj) {
      return obj.month === month && day <= obj.lastDay;
    });
    var onlyDayWasTyped = !ableToGetMonth && isDayValid;
    var onlyMonthAndDayWasTyped = ableToGetMonth && areDayAndMonthValid;
    if (onlyDayWasTyped) return true;
    if (onlyMonthAndDayWasTyped) return true;
  }
  function _onChangeRaw(text) {
    try {
      var _text, _text2, _text3;
      text = (_text = text) === null || _text === void 0 ? void 0 : _text.trim();
      var userIsErasingInput = text.length > dateText.length;
      if ((((_text2 = text) === null || _text2 === void 0 ? void 0 : _text2.length) === 2 || ((_text3 = text) === null || _text3 === void 0 ? void 0 : _text3.length) === 5) && userIsErasingInput) {
        text = "".concat(text, "/");
      }
      if (isDateValid(text)) {
        var _text4, _text5, _text6, _text7, _text8, _text9, _moment;
        var ableToGetDay = ((_text4 = text) === null || _text4 === void 0 ? void 0 : _text4.length) >= 1;
        var ableToGetMonth = ((_text5 = text) === null || _text5 === void 0 ? void 0 : _text5.length) >= 5;
        var ableToGetYear = ((_text6 = text) === null || _text6 === void 0 ? void 0 : _text6.length) >= 6;
        var day = ableToGetDay ? (_text7 = text) === null || _text7 === void 0 ? void 0 : _text7.slice(0, 2) : new Date().getDate();
        var month = ableToGetMonth ? (_text8 = text) === null || _text8 === void 0 ? void 0 : _text8.slice(3, 5) : new Date().getMonth();
        var year = ableToGetYear ? (_text9 = text) === null || _text9 === void 0 ? void 0 : _text9.slice(6, 10) : new Date().getFullYear();
        var newDate = new Date(year, month, day);
        if ((_moment = (0, _moment3.default)(newDate)) !== null && _moment !== void 0 && _moment.isValid()) {
          setDate(newDate);
        }
      }
      setDateText(text);
    } catch (error) {}
  }
  function dayMonthYearFormat(text) {
    var _date$getDate, _ref, _date$getFullYear, _day, _month;
    var date = new Date(text);
    var day = (date === null || date === void 0 || (_date$getDate = date.getDate()) === null || _date$getDate === void 0 ? void 0 : _date$getDate.toString()) || null;
    var month = (_ref = (date === null || date === void 0 ? void 0 : date.getUTCMonth()) + 1) === null || _ref === void 0 ? void 0 : _ref.toString();
    var year = (date === null || date === void 0 || (_date$getFullYear = date.getFullYear()) === null || _date$getFullYear === void 0 ? void 0 : _date$getFullYear.toString()) || null;
    day = ((_day = day) === null || _day === void 0 ? void 0 : _day.length) === 1 ? "0".concat(day) : day;
    month = ((_month = month) === null || _month === void 0 ? void 0 : _month.length) === 1 ? "0".concat(month) : month;
    return "".concat(day, "/").concat(month, "/").concat(year);
  }
  function _onChange(date) {
    var _moment2;
    if ((_moment2 = (0, _moment3.default)(date)) !== null && _moment2 !== void 0 && _moment2.isValid()) {
      var _date$toISOString;
      onChange && onChange(isDateTime ? date === null || date === void 0 ? void 0 : date.toISOString() : date === null || date === void 0 || (_date$toISOString = date.toISOString()) === null || _date$toISOString === void 0 ? void 0 : _date$toISOString.substring(0, 10));
      setIsEmpty(null);
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'wm-date-input-container ' + containerClass
  }, showTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: 'wm-label-container'
  }, mandatory && /*#__PURE__*/_react.default.createElement("span", {
    className: "wm-mandatory-mark"
  }, "*"), /*#__PURE__*/_react.default.createElement("span", {
    className: 'wm-field-label'
  }, label)), /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    value: dateText,
    onChangeRaw: function onChangeRaw(event) {
      return _onChangeRaw(event.target.value);
    },
    onBlur: function onBlur() {
      return handleOnBlur();
    },
    disabled: !editable,
    utcOffset: 0,
    className: inputClass,
    dateFormat: dateFormat || (isDateTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'),
    selected: date,
    timeFormat: "HH:mm",
    showTimeSelect: isDateTime,
    onChange: _onChange,
    showMonthDropdown: true,
    showYearDropdown: true,
    dropdownMode: dropdownMode || 'select',
    locale: _pt.default,
    onSelect: function onSelect(date) {
      setDate(date);
      setDateText(dayMonthYearFormat(date));
    }
  }), (error || mandatory && isEmpty) && /*#__PURE__*/_react.default.createElement("span", {
    className: 'wm-standard-error'
  }, (error === null || error === void 0 ? void 0 : error.message) || isEmpty));
}
var _default = exports.default = DateInput;